export const HandleFile = {
  upload:{
    url: "/file/upload",
    method: ["POST"]
  },

  getUploaded: {
    url: "/file",
    method: ["GET"]
  },

  delete: {
    url: "/file/delete",
    method: ["POST"]
  }
}